import React from 'react';
import IndustryPageTemplate from '@/components/IndustryPageTemplate';
import { solutionsAds } from '@/config/ads';

const Publishers: React.FC = () => {
  return (
    <IndustryPageTemplate
      slug="publishers"
      industry="Publishers"
      heroHeadline="Create interactive ad formats to unlock higher-value inventory and stronger direct revenue."
      heroSubheadline="Transform your ad inventory with high-impact interactive formats that command premium CPMs and strengthen advertiser relationships."
      section2Title="High-impact formats increase CPMs and create new premium sellable products."
      section2Content="Interactive ad units deliver measurably better results than static display, allowing you to price inventory at a premium. Create differentiated products that advertisers can't get anywhere else and build stronger direct relationships."
      section3Title="Audiences engage longer with interactive units than static display."
      section3Content="Interactive ads capture attention and hold it. When readers can explore, click, and interact with creative, they spend more time with the ad—delivering better outcomes for advertisers and more value from your inventory."
      section4Title="Ideal for editorial teams, sales teams, and ad operations looking to modernize and grow revenue."
      section4Content="Whether you're a digital-first publisher or a legacy media company evolving your ad products, Adventive gives you the tools to compete and win."
      heroImage="https://d64gsuwffb70l.cloudfront.net/69408eb499b5789ef7367cf9_1765838709366_36c6b285.jpg"
      heroAd={solutionsAds.publisher1}
      section2Ad={solutionsAds.publisher2}
      section3Ad={solutionsAds.publisher3}
      accentColor="bg-blue-100 text-blue-700"
      stats={[
        { value: '3x', label: 'Higher CPMs' },
        { value: '+47%', label: 'Engagement rate' },
        { value: '2.5x', label: 'Time on ad' },
        { value: '40+', label: 'Ad server integrations' },
      ]}
      benefits={[
        'Editorial teams creating sponsored content',
        'Sales teams pitching premium ad products',
        'Ad operations managing trafficking',
        'Revenue teams seeking new inventory opportunities',
      ]}
    />
  );
};

export default Publishers;
